import {PermissionType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionType'
import {PermissionResourceSchemaMap} from '@toolify/server/src/services/PermissionService/maps/PermissionResourceSchemaMap'
import {i18n} from '@toolify/client/src/setup/i18n'

const permissionTypeTitleKeyMap = (() => {
  const map = new Map<PermissionType, string>()
  for(const schema of PermissionResourceSchemaMap.values()) {
    for(const category of schema.categories) {
      for(const item of category.items) {
        if(!map.has(item.permissionType) && item.title) {
          map.set(item.permissionType, item.title)
        }
      }
    }
  }
  return map
})()

const permissionTypeEnumKeyMap = (() => {
  const map = new Map<PermissionType, string>()
  for(const [key, value] of Object.entries(PermissionType)) {
    map.set(value as PermissionType, key)
  }
  return map
})()

function humanizeEnumKey(enumKey: string): string {
  const parts = enumKey.replace(/([a-z0-9])([A-Z])/g, '$1 $2').split(' ')
  return parts
    .map((part, index) => {
      const lower = part.toLowerCase()
      if(index === 0) {
        return lower.charAt(0).toUpperCase() + lower.slice(1)
      }
      return lower
    })
    .join(' ')
}

function translateIfExists(key: string): string | null {
  const {t} = i18n.global
  const translated = String(t(key))
  if(!translated || translated === key) {
    return null
  }
  return translated
}

export function getPermissionTypeLabel(permissionType: PermissionType): string {
  const titleKey = permissionTypeTitleKeyMap.get(permissionType)
  if(titleKey) {
    const fromSchema = translateIfExists(titleKey)
    if(fromSchema) {
      return fromSchema
    }
  }

  const enumKey = permissionTypeEnumKeyMap.get(permissionType)
  if(enumKey) {
    const fromEnumKey = translateIfExists(`permissionsScreen.${enumKey}`)
    if(fromEnumKey) {
      return fromEnumKey
    }
    return humanizeEnumKey(enumKey)
  }

  return String(permissionType)
}
